import React from 'react';
import {View} from 'react-native';

import {Code, Heading, Spacer, Spacing} from '/component/base/Storybook';
import Text from '/component/base/Text';

import PercentageProgressListItem from '../PercentageProgressListItem';

import {styles} from './PercentageProgressListItem.style';

export default () => (
  <>
    <Spacing size={20}>
      <Heading level={2}>Readonly</Heading>
      <Spacer size={16} />
      <Text>
        The <Code>{'readonly'}</Code> prop is used for items that are not
        clickable.
      </Text>
    </Spacing>
    <View style={styles.wrapper}>
      <PercentageProgressListItem
        hasCheckbox
        label={<Text>Group Qualifying Volume</Text>}
        readonly
        numerator={10}
        denominator={25}
      />
    </View>
    <Spacing size={20}>
      <Code>{'readonly={true}'}</Code>
    </Spacing>
  </>
);
